import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import AppBarInput from '../../../Components/AppBarInput';
import { apiKey, server } from '../../../Config/server';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper'
import { Avatar, Grid, Typography } from '@mui/material';
import { Box } from '@mui/system';
import CarouselImage from '../../../Components/CaouselImage';

export default function DetailKegiatan() {
  const { id } = useParams()
  const [detail, setDetail] = useState(null)

  useEffect(() => {
    // Swal.showLoading()
    // axios({
    //   url: `${server}guru/detail/${id}`,
    //   method: 'get',
    //   headers: {
    //     'Content-Type': 'application/json',
    //     Authorization: `Bearer ${sessionStorage.token}`,
    //     'x-api-key': apiKey
    //   }
    // })
    //   .then(({ data }) => {
    //     setDetail(data.data)
    //     Swal.close()
    //   })
    //   .catch(err => {
    //     console.log(err);
    //   })
  }, [])

  const data = [
    { lab: 'Nama Kegiatan', key: 'nama' },
    { lab: 'Tempat', key: 'nuptk' },
    { lab: 'Waktu', key: 'jenis_k' },
    { lab: 'Penanggung Jawab', key: 'tempat_lahir' },
  ]
  

  return (
    <div className='outer-input'>
      <AppBarInput title='Detail Kegiatan' />
      <Container maxWidth='md' sx={{ py: '20px' }}>
        <Paper sx={{ borderRadius: '20px' }}>
          <div className='div-avatar-detail'>
            {/* {[1, 2, 3].map((e, i) => (
              <Avatar key={i} sx={{ width: '200px', height: '200px', marginRight: '40px' }} variant='rounded' />
            ))} */}
            <CarouselImage/>
          </div>
          <Box mt='20px'>
            <Grid container spacing={2} p='20px'>
              {
                data.map((e, i) => (
                  <Grid item sm={6} key={i}>
                    <Typography fontSize='14px'>{e.lab}</Typography>
                    <Typography fontSize='18px' fontWeight={600}>Lorem Ipsum Dolor</Typography>
                  </Grid>
                ))
              }
            </Grid>
          </Box>
        </Paper>
      </Container>
    </div>
  );
}
